import { motion } from 'motion/react';
import type { Ref } from 'react';

import Button, { ButtonSize } from '@/components/BaseLibrary/Button/Button';
import useSunrunShopStore from '@/data-store/hooks/useSunrunShopStore';
import useViewPortSize from '@/hooks/useViewportSize';

import useStyles from './Cart.styles';
import CartHeader from './CartHeader';
import CartItems from './CartItems';
import Subtotal from './Subtotal';

export default function FilledCart({ ref }: { ref?: Ref<HTMLDivElement> }) {
  const { classes } = useStyles();
  const { isExtraSmall } = useViewPortSize();
  const { cart } = useSunrunShopStore('cart');

  const handleCheckout = () => {
    if (cart?.checkoutUrl) {
      const url = new URL(cart.checkoutUrl);
      url.searchParams.append('utm_source', location.pathname);

      window.location.href = url.toString();
    }
  };

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, scale: 1 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
    >
      <div className={classes.container}>
        <CartHeader />
        <div className={classes.divider} />
        <CartItems />
        <Subtotal />
        <Button
          onClick={handleCheckout}
          label='Checkout'
          size={isExtraSmall ? ButtonSize.SM : ButtonSize.MD}
          className={classes.checkoutButton}
        />
      </div>
    </motion.div>
  );
}
